<template>
  <w-dialog :dialogShow="state" @handleClose="handleClose">
    <div slot="content" class="content">
      <div class="header">App&nbsp;暂不支持支付</div>
      <div class="desc">打开网页&nbsp;<span>wondercv.com</span>&nbsp;或前往微信支付</div>
      <ul>
        <li>可复制下载多份简历</li>
        <li>查看全部案例和关键词</li>
        <li>无限使用简历智能优化</li>
        <li></li>
      </ul>
      <div class="wechat-btn" @click="sendWechat">
        <img src="https://files.wondercv.com/wechat/icon-gray.png" alt="">
        <span>发送至微信打开</span>
      </div>
      <div class="bottom" @click="toUdesk">留言咨询客服</div>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '@/components/global/w-dialog'
	import { setupWebViewJavascriptBridge } from '@/assets/js/utils'

	export default {
		name: 'member-pay-dialog',
		props: {
			state: {
				type: Boolean,
				default: true
			}
		},
		data () {
			return {
				descriptionInfo: [
					'来自顶级名企的专业导师',
					'投行、咨询、BAT、五百强',
					'中英文简历、求职信、导师建议',
					'30 天内 1 对 1 反馈辅导'
				]
      }
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			async toUdesk () {
				let res = await this.$api.user.getUdeskOnlineUrl()
				if (this.iosOrAndroid) {
          setupWebViewJavascriptBridge((bridge) => {
            bridge.callHandler('toCustomService',
              { url: res.data.udesk_online_url },
              function responseCallback (responseData) {
              })
          })
        }
			},
			sendWechat () {
				this.$emit('sendWechat')
      },
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background-color: #fff;
    width: 80vw;
    padding: 30px 60px;
    .header {
      font-size: 18px;
      color: #404040;
      margin-bottom: 10px;
    }
    .desc {
      font-size: 14px;
      color: #6da0ec;
      text-align: center;
      margin-bottom: 20px;
      line-height: 20px;
      span {
        font-size: 13px;
      }
    }
    ul {
      margin-left: 26px;
      li {
        margin-bottom: 24px;
        color: #606060;
      }
    }
    .wechat-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      text-align: center;
      background-color: #49be63;
      border-radius: 25px;
      color: #fff;
      margin-bottom: 20px;
      font-size: 13px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }
    }
    .bottom {
      font-size: 12px;
      color: #909090;
    }
  }
</style>
